import { show } from "@ebay/nice-modal-react";
import type { useSingleton } from "@tippyjs/react";
import { useTranslation } from "react-i18next";
import { canv } from "@/canv/global";
import { CommentsIcon } from "@/icons";
import { BottomBarItem } from "@/interface/BottomBar/BottomRightBar";
import { BuyProModal } from "@/interface/ui/modals/BuyProModal";
import { Tooltip } from "@/interface/ui/Tooltip";

type Props = {
    singletoneTarget: ReturnType<typeof useSingleton>[1];
    isActive: boolean;
    disabledClass: string;
    className?: string;
};

export const Comments = ({ singletoneTarget, isActive, disabledClass, className }: Props) => {
    const { t } = useTranslation();
    const isFreeUser = !canv.getInitDataProp("isProfessional");

    const openCommentsWindow = () => canv.appInterface.commentsWindow.open();

    const openFreeModal = () => {
        show(BuyProModal, { feature: "comments" });
    };

    if (isFreeUser) {
        return (
            <BottomBarItem className={className} active={isActive} onClick={openFreeModal}>
                <CommentsIcon className={disabledClass} />
            </BottomBarItem>
        );
    }

    return (
        <Tooltip singleton={singletoneTarget} content={t("comments.title")}>
            <BottomBarItem className={className} active={isActive} onClick={openCommentsWindow}>
                <CommentsIcon />
            </BottomBarItem>
        </Tooltip>
    );
};
